module.exports = __webpack_public_path__ + "static/media/exchage_feature_performance.226c29b6.png";